import { COUNTRY_LIST_ID } from './constants';

// get scroll container (two elements above list due to extra div in scrollbar)
export const getHeatmapCountryListScrollContainer = () =>
  document.querySelector<HTMLDivElement>(`#${COUNTRY_LIST_ID}`)?.parentElement
    ?.parentElement;
